import React from 'react';
import { Badge, Card, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
import { ExclamationTriangle } from 'react-bootstrap-icons';
import { ALARM_STATUS_NEW } from '../../../constants';

const SystemAlerts = ({ alarms, onAlarmClick, currentTimezone }) => {
    const statusClass = alarms.TotalAlarms > 0 ? 'danger' : 'success';
    return (
        <Card className={`border-${statusClass} mb-4  shadow h-99 flex-grow-1`} style={{ minHeight: '200px' }}>
            <Card.Header className={`bg-${statusClass} text-white d-flex justify-content-between align-items-center`}>
                <span className="fw-bold fs-6"><FormattedMessage id="unitOverview.newAlarms" defaultMessage="New Alarms" /></span>
                <Badge bg="light" text={statusClass} pill>{alarms.TotalAlarms || 0}</Badge>
            </Card.Header>
            <Card.Body className="d-flex flex-column overflow-auto">
                {alarms.TotalAlarms === 0 && (
                    <div className="d-flex justify-content-center align-items-center flex-grow-1">
                        <span className="text-muted fs-4">
                            <FormattedMessage id="unitOverview.noAlarms" defaultMessage="No alarms" />
                        </span>
                    </div>
                )}

                {alarms.AlarmData && alarms.AlarmData.map(alarm => {
                    return (
                        <AlarmItem key={uuidv4()} alarm={alarm} currentTimezone={currentTimezone} />
                    );
                })}

                {alarms.TotalAlarms > 0 && (
                    <div className="mt-3 text-center">
                        <Button variant="outline-danger" size="md" onClick={(e) => {
                            e.stopPropagation();
                            onAlarmClick(ALARM_STATUS_NEW);
                        }}>
                            <FormattedMessage id="unitOverview.viewAllAlarms" defaultMessage="View all Alarms" />
                        </Button>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default SystemAlerts;


const AlarmItem = ({ alarm, currentTimezone }) => {
    const timestampInSeconds = parseInt(alarm.EventDateTime.slice(0, 10), 10);
    return (
        <div className="d-flex align-items-center mb-2">
            <ExclamationTriangle className={`text-danger me-2`} size={16} />
            <span className="fs-5">{` ${alarm.EventTitle} at ${moment.unix(timestampInSeconds).tz(currentTimezone)}`}</span>
        </div>
    );
}